export enum ICON_COLOR {
  yellow,
  red,
  magenta,
  purple,
  indigo,
  green,
  lightGreen,
  pink,
  blue,
}

export const ICON_BACKGROUND = {
  [ICON_COLOR.yellow]: 'var(--x-icon-bg-yellow)',
  [ICON_COLOR.red]: 'var(--x-icon-bg-red)',
  [ICON_COLOR.magenta]: 'var(--x-icon-bg-magenta)',
  [ICON_COLOR.purple]: 'var(--x-icon-bg-purple)',
  [ICON_COLOR.indigo]: 'var(--x-icon-bg-indigo)',
  [ICON_COLOR.lightGreen]: 'var(--x-icon-bg-light-green)',
  [ICON_COLOR.green]: 'var(--x-icon-bg-green)',
  [ICON_COLOR.pink]: 'var(--x-icon-bg-pink)',
  [ICON_COLOR.blue]: 'var(--x-icon-bg-blue)',
};

export const ICON_FILL = {
  [ICON_COLOR.yellow]: 'var(--x-icon-fill-yellow)',
  [ICON_COLOR.red]: 'var(--x-icon-fill-red)',
  [ICON_COLOR.magenta]: 'var(--x-icon-fill-magenta)',
  [ICON_COLOR.purple]: 'var(--x-icon-fill-purple)',
  [ICON_COLOR.indigo]: 'var(--x-icon-fill-indigo)',
  [ICON_COLOR.lightGreen]: 'var(--x-icon-fill-light-green)',
  [ICON_COLOR.green]: 'var(--x-icon-fill-green)',
  [ICON_COLOR.pink]: 'var(--x-icon-fill-pink)',
  [ICON_COLOR.blue]: 'var(--x-icon-fill-blue)',
};
